<shared-dashboard-header
  class="dashboard-header"
  data-testid="dashboard-header"
  (toggleConversationList)="toggleConversationList()" />
@let showConversationList = conversationListOpen();
<div class="inner-dashboard" [ngClass]="{ 'show-conversation-list': showConversationList }">
  @if (showConversationList) {
    <div
      class="backdrop-overlay"
      (click)="closeConversationList()"
      tabindex="0"
      role="button"
      aria-label="Close menu"></div>
  }
  <div class="conversation-list-wrapper">
    <shared-conversation-list data-testid="conversation-list" />
  </div>
  <div
    cdkDropList
    cdkDropListOrientation="horizontal"
    cdkScrollable
    #activeConversationList
    class="active-conversation-list"
    data-testid="active-conversation-list"
    (cdkDropListDropped)="drop($event)">
    @for (
      clientConversation of activeConversationStore.entities();
      track clientConversation.id;
      let idx = $index
    ) {
      <shared-conversation-item
        cdkDrag
        [conversationId]="clientConversation.id"
        [conversationTypeId]="clientConversation.conversationTypeId"
        [conversationTypes]="conversationTypeStore.types()"
        [user]="userStore.getUser()"
        [isActive]="true"
        (click)="setConversationInFocus(clientConversation.id)"
        (messageRead)="handleMessageRead($event)"
        (conversationItemInited)="handleConversationOpened($event)"
        [isCloseable]="true"
        [isDraggable]="true" />
    }
  </div>
</div>
@let errors = globalErrors();
@if (errors && errors.length > 0 && errors[0]) {
  @let error = errors[0];
  <shared-global-error
    [message]="error.message ?? error.code | translate"
    [unknownError]="true"
    [hasReload]="true"
    (reload)="reloadPage()" />
}
